export default __webpack_public_path__ + "static/media/punto-originario-a2u-selected.8ced1abb.svg";